const headerData = [{
		types: "selection",
		columnwidth: 50,
	},
	{
		prop: "INTypeName",
		label: "类型",
		columnwidth: 70,
	},
	{
		prop: "INName",
		label: "名称",
		columnwidth: 120,
	},
	{
		prop: "InvClassName",
		label: "产品线",
		columnwidth: 100,
	},
	{
		prop: "ProvinceName",
		label: "省市",
		columnwidth: 150,
	},
	{
		prop: "InvName",
		label: "产品",
		columnwidth: 150,
	},
	{
		prop: "LEVEL3",
		label: "LEVEL3",
		columnwidth: 150,
	},
	{
		prop: "CusName",
		label: "经销商",
		columnwidth: 150,
	},
	{
		prop: "ExecuteDate",
		label: "执行日期",
		columnwidth: 125,
	},
	{
		prop: "LowNTSPrice",
		label: "最低采购价",
		columnwidth: 100,
	},
	{
		prop: "HighNTSPrice",
		label: "最高采购价",
		columnwidth: 100,
	},
	{
		prop: "HighIMSPrice",
		label: "最高植入价",
		columnwidth: 100,
	},
	{
		prop: "INMID",
		label: "单据号",
		columnwidth: 150,
	},
	{
		prop: "CreatorName",
		label: "创建人",
		columnwidth: 150,
	},
	{
		prop: "CreateTime",
		label: "创建时间",
		columnwidth: 125,
	}
];
export default headerData;